import styled from 'styled-components';

export const StyledDragHandle = styled.div`
  z-index: 100;
  cursor: cell;
  width: 8px;
  height: 8px;
`;
export const StyledFormCellWrapper = styled.div<{ $canEdit: boolean; $isEditing: boolean }>`
  font-weight: 500;
  font-feature-settings: 'cv01', 'cv10', 'tnum';
  cursor: ${props => (props.$canEdit ? 'pointer' : '')};
  --bs-focus-ring-color: transparent;
  --bs-bg-opacity: ${props => (props.$isEditing ? 0.1 : 0.3)};
`;
